/* ENEA: collection pages never receive the body.has-scrolled class from the theme, so
 * the sticky header goes blank/white when you scroll. theme.dev.js only wires its own
 * headerState() up when the header is fixed AND the page has no collection filters, and
 * these collection pages have filters, so nothing else sets the class here. This does.
 * Collection templates only. Self contained. (2026-06-26, reworked 2026-08-18)
 * To revert: delete this file and its script tag in snippets/loading.liquid.
 *
 * REWORKED 2026-08-18, after three failed attempts at an iOS header bounce.
 *
 * The bounce was never a single bad calculation. Three separate pieces of code owned
 * this one class and disagreed about where the line sits:
 *
 *   layout/theme.liquid   added it above 6px, never removed it, and re-added it from a
 *                         MutationObserver on the body class, so it overruled everyone
 *   this file             toggled on and off at 60
 *   theme.dev.js          toggles on and off at 87, header 60 plus announcement 27
 *
 * Anywhere between 6 and 87 the observer and a toggle fought: the toggle removed the
 * class, the observer put it straight back, the toggle removed it again. The header
 * moves by its own height each time that happens. The owner's logs caught it exactly,
 * 31 flips in 6.7 seconds and 13 in a second run, at scroll positions of 11 to 42,
 * every single one inside that band. On desktop you cross 6 to 87 in one wheel tick so
 * you rarely sit in it. On iOS the URL bar collapsing and expanding keeps the position
 * hovering inside it for seconds at a time, which is why only his phone ever showed it.
 *
 * The observer in theme.liquid is gone, so there is one owner per page type now. Two
 * things here guard against it coming back:
 *
 *   The line is measured the same way theme.dev.js measures it, header height plus
 *   announcement height, rather than a hardcoded number that can drift away from it.
 *
 *   There is a dead band around that line. The class goes on above it and only comes
 *   off well below it. A viewport that keeps nudging the scroll position back and forth
 *   across a single point cannot flip the state any more, which is the exact condition
 *   the URL bar creates.
 */
(function () {
  try {
    if (!document.body || !document.body.classList.contains('template-collection')) return;

    var HYSTERESIS = 24; /* px below the line before the compact header is given up */
    var scrolled = false;

    function threshold() {
      /* same inputs headerState() uses, so the two can never disagree about the line */
      var header = document.querySelector('[data-site-header]');
      var wrapper = document.querySelector('[data-announcement-wrapper]');
      var headerHeight = 0;

      if (header) {
        headerHeight = parseInt(header.getAttribute('data-height'), 10);
        if (isNaN(headerHeight)) headerHeight = header.offsetHeight || 0;
      }

      return headerHeight + (wrapper ? wrapper.offsetHeight : 0);
    }

    function update() {
      var y = window.scrollY || window.pageYOffset || 0;
      var line = threshold();
      var next = scrolled ? y > line - HYSTERESIS : y > line;

      if (next === scrolled) return; /* leave the DOM alone when nothing changed */

      scrolled = next;
      document.body.classList.toggle('has-scrolled', scrolled);
      document.documentElement.classList.toggle('has-scrolled', scrolled);
    }

    window.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update, {passive: true});
    update();
  } catch (e) {}
})();
